module.exports = __webpack_public_path__ + "assets/5e5667c7cae085cefaf55631323b4ce1.jpg";